module.exports = __webpack_public_path__ + "img/radiaIcon0.09cfb784.png";